<template>
  <div>
    <VerifiedLable
      v-if="!hideTitle"
      :title="title"
      :disableMLtitle="disableMLtitle"
      :tooltipLabel="tooltipLabel"
    />
    <div class="search-wrapper">
      <svg class="svg-icons svg-serach">
        <use
          :xlink:href="require('@/assets/img/icons/magnify.svg') + '#layer'"
        ></use>
      </svg>
      <input
        class="search-component"
        ref="search-component"
        name="search-component"
        key="search-component"
        type="text"
        v-model.trim="search"
        :maxlength="maxlength"
        :placeholder="placeholder ? placeholder : this.$t('busca')"
        @input="onSearch(search)"
        @keydown="onKeyDown"
        :autocomplete="autocomplete ? 'on' : 'off'"
        :role="autocomplete ? 'none' : 'presentation'"
      />
    </div>
  </div>
</template>

<script>
import VerifiedLable from "@/components/shared/VerifiedLable.vue";

export default {
  name: "SearchBar",
  components: {
    VerifiedLable,
  },
  props: {
    clean: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    onSearch: {
      type: Function,
      default: () => {},
    },
    maxlength: {
      type: Number,
      default: 200,
    },
    onKeyDown: {
      type: Function,
      default: () => {},
    },
    startSearchWith: {
      type: String,
      default: "",
    },
    autocomplete: {
      type: Boolean,
      default: false,
    },
    /* Caso tenha uma informação adicional sobre o campo */
    tooltipLabel: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "busca-label",
    },
    disableMLtitle: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
    };
  },
  created() {
    this.search = this.startSearchWith;
    this.onSearch(this.search);
  },
  watch: {
    clean(val) {
      if (val) this.cleanSearch();
    },
  },
  methods: {
    cleanSearch() {
      this.search = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  width: 100%;
  height: 40px;
  border: 1px solid #e1e1e1;
  display: flex;
  position: relative;
  border-radius: 3px;

  .search-component {
    border: none;
    padding: 10px 5px 10px 40px;
    color: $darker-gray-color;
  }

  .svg-serach {
    position: absolute;
    fill: $light-gray-color;
    height: 100%;
    width: 35px;
    padding: 2px 2px 2px 8px;
    background-color: transparent;
  }
  .svg-search-clean {
    cursor: pointer;
    position: absolute;
    fill: $darker-gray-color;
    height: 100%;
    width: 35px;
    padding: 2px 8px 2px 2px;
    background-color: transparent;
    right: 0;
  }
}
</style>
